import {
    SET_SELECTED_BEST_OFFER,
    GET_BEST_OFFERS_FULFILLED,
    GET_BEST_OFFERS_PENDING,
} from '../../../constants/ActionTypes';
import selectBestOfferInitialState from './selectBestOfferInitialState';

function selectBestOfferReducer(state = selectBestOfferInitialState, action) {
    switch (action.type) {
    case SET_SELECTED_BEST_OFFER: {
        return {
            ...state,
            selectedOffer: action.offer,
        };
    }
    case GET_BEST_OFFERS_PENDING: {
        return {
            ...state,
            isPending: true,
            bestOffers: [],
        };
    }
    case GET_BEST_OFFERS_FULFILLED: {
        return {
            ...state,
            isPending: false,
            bestOffers: action.payload.products,
        };
    }
    default:
        return state;
    }
}

export default selectBestOfferReducer;



// WEBPACK FOOTER //
// ./src/app/FormStepper/SelectBestOffer/selectBestOfferReducer.js